import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import { IoMdBriefcase } from "react-icons/io";
const Item = ({
  item,

  moduleConfig,

  confirmAndDisabled,
  confirmAndEnabled,
  customButtonsForItems,
}) => {
  const fields = moduleConfig.fields;
  const getItems = () => {
    let items = [];

    if (item.joiningTime) {
      items = [
        ...items,
        {
          text: "Joining Time",
          value: item.joiningTime,
          type: "text",
        },
      ];
    }
    if (item.employmentType) {
      items = [
        ...items,
        {
          text: "Employment Type",
          value: item.employmentType,
          type: "text",
        },
      ];
    }

    if (item.postedDate) {
      items = [
        ...items,
        {
          text: "Posted Date",
          value: item.postedDate,
          type: "date",
        },
      ];
    }
    // if (item.description) {
    //   items = [
    //     ...items,
    //     { text: "Description", value: item.description, type: "text" },
    //   ];
    // }

    return items;
  };
  return (
    <Card className="item mb-2 borderCream">
      {(item.status === "0" || item.status === 0) && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            background: "rgba(0,0,0,0.2)",
            width: "100%",
            height: "100%",
            zIndex: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: "20px",
            fontWeight: "600",
            backdropFilter: "blur(1px)",
            borderRadius: "inherit",
          }}
        ></div>
      )}
      <Card.Header className="ps-1 pe-2 py-0">
        <Card.Title className="d-flex m-0 p-0">
          <div className="d-flex align-items-center ImageSectionSpacing">
            <div className="checkboxCol me-2 mt-2"></div>

            <div className="ms-1 me-2 position-relative">
              <IoMdBriefcase size={35} className="text-secondary mt-1" />
              {(item.status === "0" || item.status === 0) && (
                <i className="fas fa-ban position-absolute mb-2 mt-1 banned4"></i>
              )}
            </div>
            <div className="d-flex flex-column ms-1">
              <span className="m-0 text-bold memberName text-red">
                {item.title}
              </span>
              <span className="text-custom-4 mt-1 small text-bold">{item.salary}</span>
            </div>
          </div>
        </Card.Title>

        <div
          className="card-tools endColumn mb-1 pt-1"
          style={{ zIndex: 101, position: "relative" }}
        >
          <div>
            {item.galleryAlbumId && (
              <span className="badge badge-warning me-1 text-dark">
                Attached Gallery
              </span>
            )}
            {(item.showOnHomePage === "1" || item.showOnHomePage === 1) && (
              <span className="badge homePageShow me-1 text-white">
                Showing on Home Page
              </span>
            )}
            <span className="badge badge-light me-1 text-dark">
              Status :{" "}
              <span className="text-secondary">
                <ModuleDisplayBoolean
                  value={item.status}
                  trueValue="Enabled"
                  falseValue="Disabled"
                />{" "}
              </span>
            </span>
            {item.createdAt && (
              <span className="badge badge-light me-1 text-dark">
                Created Date :{" "}
                <span className="text-secondary">
                  <ModuleDisplayDate value={item.createdAt} />{" "}
                </span>
              </span>
            )}
          </div>

          <div className=" text-right me-xl-2  mt-1">
            <Link
              to={`/${moduleConfig.url}/${item._id}`}
              className="btn btn-outline-secondary  listingActionIcon"
              title={`View ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-eye"></i>
            </Link>

            <Link
              to={`/${moduleConfig.url}/update/${item._id}`}
              className="btn btn-outline-secondary listingActionIcon"
              title={`Update ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            {(item.status === "1" || item.status === 1) && (
              <span
                title={`Disable ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndDisabled(item._id)}
                className="btn btn-outline-secondary  listingActionIcon"
              >
                <i className="fas fa-ban"></i>
              </span>
            )}

            {(item.status === "0" || item.status === 0) && (
              <span
                title={`Enable ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndEnabled(item._id)}
                className="btn btn-outline-secondary listingActionIcon"
              >
                <i className="fas fa-undo"></i>
              </span>
            )}
          </div>
        </div>
      </Card.Header>
      <Card.Body className="px-1 py-0">
        <Row>
          <Col className="mt-1 mb-1 ">
            {/* <StatsListing heading="Cart" clickable items={getCart()} /> */}
            <StatsListing items={getItems()} />
          </Col>
        </Row>
        <Row>
          <Col className="">
            {item.shortDescription && (
              <Alert className="alert-custom-3 d-flex mb-1  flex-wrap px-1 py-0 font-small">
                <strong className="me-1 mt-1 text-custom-1">
                  Short Description:
                </strong>
                <div className=" d-flex align-items-center flex-wrap p-1 font-small">
                  <span
                    className="font-small text-normal text-custom-1 html"
                    dangerouslySetInnerHTML={{ __html: item.shortDescription }}
                  ></span>
                </div>
              </Alert>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Item;
